import sectionCardMediaSlider03Css from '../css-snippets/section-card-media-slider-03';

const html = `
<style>${sectionCardMediaSlider03Css}</style>
<div
  id="card-container-unique-id"
  data-attribute="card-container"
  data-id="unique-id"
  data-background-color="#F9F9F9"
  data-card-item-background-color="#ffffff"
  data-top-padding="true"
  data-bottom-padding="true"
  data-pagination-active-color="#000000"
  data-pagination-inactive-color="#cccccc"
  style="
    background-color: #F9F9F9;
  "
>
  <div
    class="container-page"
    data-attribute="container-page"
    data-show-style="true"
    style="background-color: transparent"
  >
    <div class="wrap-card container">
      <div
        data-attribute="card-header"
        data-show="true"
        class="card-header"
        style="display: block"
      >
        <h2 style="text-align: center">
          <strong>Save Time and Money</strong>
        </h2>
        <p style="text-align: center">
          You can save time and money with Airmoto. No more waiting in line at
          the gas station, paying for air, or calling <br /> a tow truck. Airmoto is
          the perfect solution for your inflation needs.
        </p>
      </div>
      <div class="swiper swiper-video-unique-id">
        <div
          data-attribute="list-item"
          class="swiper-wrapper"
          data-pagination-active-color="#000000"
          data-pagination-inactive-color="#cccccc"
        >
          <div data-attribute="item" class="swiper-slide">
            <div class="wrap-item">
              <img
                loading="lazy"
                data-attribute="card-image"
                src="https://cdn.skyfastimg.com/images/2026/02/25/image-699e669d31328ddb4958ed98.webp?w=500&h=50&q=80"
                alt=""
              />
              <div class="wrap-item-content">
                <h3 style="text-align: center">
                  <strong>Avoid Being Stranded</strong>
                </h3>
                <p style="text-align: center">
                  Stranded on the side of the road? Airmoto can help you get
                  back on the road in minutes.
                </p>
              </div>
            </div>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <div class="wrap-item">
              <img
                loading="lazy"
                data-attribute="card-image"
                src="https://cdn.skyfastimg.com/images/2026/02/25/image-699e66c2e535e2b4e7b6d0c6.webp?w=500&h=50&q=80"
                alt=""
              />
              <div class="wrap-item-content">
                <h3 style="text-align: center">
                  <strong>Avoid Gas Stations</strong>
                </h3>
                <p style="text-align: center">
                  Gas station out of order or charging for air? Airmoto saves you time and money.
                </p>
              </div>
            </div>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <div class="wrap-item">
              <img
                loading="lazy"
                data-attribute="card-image"
                src="https://cdn.skyfastimg.com/images/2026/02/25/image-699e66d3415a551ac75634fc.webp?w=500&h=50&q=80"
                alt=""
              />
              <div class="wrap-item-content">
                <h3 style="text-align: center">
                  <strong>Avoid Tow Trucks</strong>
                </h3>
                <p style="text-align: center">
                  Forget calling a tow truck for a flat tire. Airmoto is the perfect solution for your inflation needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</div>

`;
export default html;
